export default (input) => {
  return input.toUpperCase()
}



// WEBPACK FOOTER //
// ./src/filter/filter-uppercase.js